import PropTypes from 'prop-types';
import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Box } from '@material-ui/core';

const useStyles = makeStyles(() => ({
  customizeContainer: {
    height: 600,
    overflowY: 'auto',
  },
}));

function ConsentTabContainer(props) {
  const { children, value, index, ...other } = props;
  const classes = useStyles();

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`consent-tabpanel-${index}`}
      aria-labelledby={`consent-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box my={4} className={classes.customizeContainer}>
          {children}
        </Box>
      )}
    </div>
  );
}

ConsentTabContainer.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

export default ConsentTabContainer;
